import { IonButtons, IonCol, IonContent, IonGrid, IonHeader, IonItem, IonLabel, IonMenuButton, IonPage, IonRow, IonTitle, IonToolbar } from '@ionic/react';
import React from 'react';
//import { useParams } from 'react-router';
import './Ia.css';
import OpenMenuButton from "../../../components/OpenMenuButton";

const Ia: React.FC = () => {

 const name:string = "B1-IA";

 const now = new Date();
 const dummy = now.getDate()+ '_' + now.getSeconds()+ '_' + now.getMinutes() + '_' + now.getHours();

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton />
            <OpenMenuButton />
          </IonButtons>
          <IonTitle>{name}</IonTitle>
        </IonToolbar>
      </IonHeader>

      <IonContent>
        <IonHeader collapse="condense">
          <IonToolbar>
            <IonTitle>{name}</IonTitle>
          </IonToolbar>
        </IonHeader>

        <IonGrid>
                  <IonItem detail={true} className="ion-no-padding" routerLink={"/page/home/ia/form/0/"+dummy} onClick={(e) => {}}>
                  <IonRow className="ion-align-items-start">
                  <IonCol>
                    <IonLabel className="ion-text-wrap">
                    <span dangerouslySetInnerHTML={{__html: "Click me"}}></span>
                    </IonLabel>
                  </IonCol>
                  </IonRow>
                  </IonItem>
          </IonGrid>

      </IonContent>
    </IonPage>
  );
};

export default Ia;
